import styled from 'styled-components'

import { mediaQueries } from '@fourthwall/components'

export const Container = styled.div`
  display: grid;

  gap: 16px;
  grid-auto-flow: column;
  grid-template-columns: 1fr 32px;
  align-items: center;

  width: 100%;
`

export const InputsContainer = styled.div`
  display: grid;
  gap: 16px;
  width: 100%;
`

export const Bottom = styled.div`
  display: grid;
  grid-auto-flow: row;
  gap: 16px;

  ${mediaQueries.tablet} {
    grid-auto-flow: column;
    grid-template-columns: 1fr 1fr;
  }
`
